import $fn from '@/utils/fn';
export const operation = {
    columnsBalance: [{
            title: "交易时间",
            key: "pay_time",
            align: "center",
            render: (h, params) => {
                return h(
                    "span", {
                        props: {},
                    },
                    $fn.toTimes(params.row.pay_time)
                );
            },
        },
        {
            title: "交易订单号",
            key: "pay_order",
            align: "center",
        },
        {
            title: "交易类型",
            key: "pay_way",
            slot: "pay_way",
            align: "center",
        },
        {
            title: "收入(盒币)",
            key: "income",
            align: "center",
            render: (h, params) => {
                return h(
                    "span", {
                        style: {
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "#FF5F00"
                        }
                    },
                    params.row.income
                );
            }
        },
        {
            title: "支出(盒币)",
            key: "expend",
            align: "center",
            render: (h, params) => {
                return h(
                    "span", {
                        style: {
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "#08C47E"
                        }
                    },
                    params.row.expend
                );
            }
        },
        /* {
            title: "盒币余额",
            key: "balance",
            align: "center",
            render: (h, params) => {
                return h(
                    "span", {
                        style: {
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "#000000"
                        }
                    },
                    params.row.balance
                );
            }
        }, */
        {
            title: "支付方式",
            key: "pay_type",
            slot: "pay_type",
            align: "center",
        },
    ],
    columnsGold: [{
            title: "交易时间",
            key: "pay_time",
            align: "center",
            render: (h, params) => {
                return h(
                    "span", {
                        props: {},
                    },
                    $fn.toTimes(params.row.pay_time)
                );
            },
        },
        {
            title: "交易订单号",
            key: "pay_order",
            align: "center",
        },
        {
            title: "交易类型",
            key: "pay_way",
            slot: "pay_way",
            align: "center",
        },
        {
            title: "收入(金币)",
            key: "income",
            align: "center",
            render: (h, params) => {
                return h(
                    "span", {
                        style: {
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "#FF5F00"
                        }
                    },
                    params.row.income
                );
            }
        },
        {
            title: "支出(金币)",
            key: "expend",
            align: "center",
            render: (h, params) => {
                return h(
                    "span", {
                        style: {
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "#08C47E"
                        }
                    },
                    params.row.expend
                );
            }
        },
        {
            title: "剩余金币",
            key: "consume",
            align: "center",
        }
    ]
};